import * as React from "react";
const WaterTreatmentAndMiningSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M21.75 5.968a31.774 31.774 0 0 0-5.181-4.787 1 1 0 0 0-1.148 0 31.772 31.772 0 0 0-5.171 4.787C6.814 9.915 5 14.075 5 18a11 11 0 1 0 22 0c0-3.925-1.814-8.085-5.25-12.032ZM16 27a9.01 9.01 0 0 1-9-9c0-7.154 6.934-13.125 9-14.75 2.066 1.625 9 7.594 9 14.75a9.01 9.01 0 0 1-9 9Zm6.986-7.833a7.2 7.2 0 0 1-5.82 5.819 1 1 0 1 1-.331-1.973c2.071-.348 3.829-2.106 4.18-4.18a1 1 0 1 1 1.973.334h-.002Z"
    />
  </svg>
);
export default WaterTreatmentAndMiningSVG;
